import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Typography from "../../../../components/Typography/Typography";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import IconComponent from "../../../../components/Icon/IconComponent";
import {
  GREY,
  BASE,
  BORDER,
  WARNING,
} from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";
import { INITIAL_ROUTE } from "../../../../utils/constants/routes";

const OnboardingPaymentCancel = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: BASE.BACKGROUND,
      padding: "24px",
    },
    card: {
      background: BASE.WHITE,
      borderRadius: "12px",
      padding: "48px",
      maxWidth: "500px",
      width: "100%",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
      border: `1px solid ${BORDER.DEFAULT}`,
    },
    iconWrapper: {
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      background: WARNING.W_50,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    warningIcon: {
      fontSize: "40px",
      color: WARNING.W_500,
    },
  };

  useEffect(() => {
    // Automatically redirect back after a short delay or immediately
    const timer = setTimeout(() => {
      navigate(INITIAL_ROUTE);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box style={styles.container}>
      <Box style={styles.card}>
        <Box style={styles.iconWrapper}>
          <IconComponent
            iconLabel={ICON_LABELS.WARNING}
            style={styles.warningIcon}
          />
        </Box>
        <Typography
          size={"lg"}
          color={GREY.PRIMARY}
          fontWeight={fontWeight.BOLD}
          label="Payment Cancelled"
        />
        <TypographyInline
          size={"sm"}
          color={GREY.SECONDARY}
          fontWeight={fontWeight.REGULAR}
          label="You cancelled the payment. We are taking you back to choose a plan."
        />
      </Box>
    </Box>
  );
};

export default OnboardingPaymentCancel;
